import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function SkillsBarChart({ data = [] }) {
	return (
		<div style={{ width: '100%', height: 240 }}>
			<ResponsiveContainer>
				<BarChart data={data}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="skill" />
					<YAxis />
					<Tooltip />
					<Bar dataKey="count" fill="#14b8a6" />
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
}


